export default "__VITE_ASSET__CJ8ve0oo__"